import Reports from 'src/pages/Reports/Reports'
import ReportsIndex from 'src/pages/Reports/ReportsIndex'

const path = 'reports'
const title = 'Relatórios'

export default {
  path: path,
  component: Reports,
  children: [
    {
      path: '',
      name: `${path}.index`,
      component: ReportsIndex,
      meta: {
        title: title,
        requireAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/reports.js